// @mui
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
// theme
import { hideScroll } from "src/theme/css";
import { navSurface } from "src/theme/palette";
// hooks
import { useAuthContext } from "src/auth/hooks";
// components
import Logo from "src/components/logo";
import { NavSectionMini } from "src/components/nav-section";
import { paths } from "src/routes/paths";
//
import { NAV } from "../config-layout";
import { useNavData } from "./config-navigation";
import { NavToggleButton } from "../_common";

// ----------------------------------------------------------------------

export default function NavMini() {
  const { user } = useAuthContext();

  const navData = useNavData();

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: "fixed",
          width: NAV.W_MINI,
          bgcolor: navSurface,
          ...hideScroll.x,
        }}
      >
        <Logo
          variant="mark"
          onDark
          href={paths.dashboard.root}
          sx={{ mx: "auto", my: 2, width: 40 }}
        />

        <NavSectionMini
          data={navData}
          config={{
            currentRole: user?.enterpriseRole || [],
            contrast: true,
          }}
        />
      </Stack>
    </Box>
  );
}
